import { useContext } from 'react';
import BookingContext, { initialBookingState } from '../../contexts/BookingContext/BookingContext';
import { TomTomApiResult } from '../../types/TomTom/TomTomApiResult';

const useBooking = () => {
  const { booking, setBooking } = useContext(BookingContext);
  const { name, phoneNumber, destination, passengers, email } = booking;

  const setName = (name: string) => {
    setBooking?.(prev => ({ ...prev, name }));
  };

  const setPhoneNumber = (phoneNumber: string) => {
    setBooking?.(prev => ({ ...prev, phoneNumber }));
  };

  const setDestination = (destination?: TomTomApiResult) => {
    setBooking?.(prev => ({ ...prev, destination }));
  };

  const setPassengers = (passengers: number) => {
    setBooking?.(prev => ({ ...prev, passengers }));
  };

  const setEmail = (email: string) => {
    setBooking?.(prev => ({ ...prev, email }));
  };

  const resetBooking = () => {
    setBooking?.(initialBookingState);
  };

  return {
    booking,
    setName,
    name,
    setPhoneNumber,
    phoneNumber,
    destination,
    setDestination,
    passengers,
    setPassengers,
    email,
    setEmail,
    resetBooking,
  };
};

export default useBooking;
